import React, { useState, useEffect } from 'react';



import './properties.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


import { Link } from 'react-router';
import { IoSearchSharp } from "react-icons/io5";

// import Pagination from "react-js-pagination";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

import Dropdown from 'react-bootstrap/Dropdown';

import { IoMdCheckmark } from "react-icons/io";
import { IoIosMore } from "react-icons/io";
import { AiOutlineEdit } from "react-icons/ai";



import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import FormatPrice from '../../components/property/formatPrice';
import AccountSidebar from '../../components/sidebar/accountSidebar';
import CustomPagination from '../../components/pagination/customPagination';

import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';
import config from '../../config/config';


const Properties = ({getSelfProperties, selfListing}) => {   
    const [ currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
		loadData();
	},[]);

    const loadData = async() => {
        await getSelfProperties({token: localStorage.getItem('user'), page: currentPage}).then(res => {
            // console.log()
        })
    }

    const handlePageChange = (page) => {
        if (page >= 1 && page <= selfListing.pagination.total_pages) {
          setCurrentPage(page);
        }
    };


    console.log('selfListing', selfListing)
    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <AccountSidebar />
                        <Col lg={9}>
                            <div class="card shadow p-4">
                               <div>
                               {/* <Form>
                                    <Row>
                                        <Col xs={6} xl={3}>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text id="basic-addon1"><IoSearchSharp /></InputGroup.Text>
                                                <Form.Control
                                                placeholder="Ads tittle, keyword..."
                                                aria-label="Ads tittle, keyword..."
                                                aria-describedby="basic-addon1"
                                                />
                                        </InputGroup>
                                        </Col>

                                        <Col xs={6} xl={3}>
                                            <Form.Select aria-label="All Category">
                                                <option>All Category</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Col>
                                        <Col xs={6} xl={3}>
                                            <Form.Select aria-label="Recently posted">
                                                <option>Recently posted</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Col>
                                        <Col xs={6} xl={3}>
                                            <Form.Select aria-label="All">
                                                <option>All</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                </Form> */}
                                {
                                    selfListing && selfListing.properties && selfListing.properties.length > 0 ?
                                        <div>
                                            <div className='ad-list d-flex mb-2'>
                                                <div className='d-flex info'>
                                                    Ads
                                                </div>
                                                <div>Date</div>
                                                <div> Prices</div>
                                                <div>Status</div>
                                                <div>
                                                    Action
                                                </div>
                                            </div>
                                            {
                                                selfListing.properties.map((property, propertyIndex) => {
                                                            return <div className='ad-list d-flex mb-3 border-bottom border-secondary'>
                                                                        <div className='d-flex info'>
                                                                            <img src={`${config.uploadUrl}${property.image}`} className='me-2 flex-1  mb-0' style={{maxHeight: '60px'}} />
                                                                            <div>
                                                                                <h6>{property.title}</h6>
                                                                                <p>{property.type}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div>{property.created_at}</div>
                                                                        <div>{property.price ? <FormatPrice price={property.price} /> : ''}</div>
                                                                        <div>{ property.status == 'Active' ? <span className='text-success'><IoMdCheckmark /> {property.status}</span> : <span className='text-danger'>{property.status}</span>}</div>
                                                                        <div>
                                                                            <Link to={`/property/update/${property.slug_url}`} className="btn btn-light"><AiOutlineEdit/>  Edit</Link>
                                                                            {/* <Dropdown  className='d-inline-block ms-2'>
                                                                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                                                                    <IoIosMore />
                                                                                </Dropdown.Toggle>
                                
                                                                                <Dropdown.Menu>
                                                                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                                                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                                                                </Dropdown.Menu>
                                                                            </Dropdown> */}
                                                                        </div>
                                                                    </div>
                                                })
                                            }
                                        </div>
                                    : ''
                                }
                                    
                                    
                                    
                                    <div className="justify-content-center d-flex">
                                        {
                                            selfListing.pagination
                                             ? 
                                                <CustomPagination 
                                                    totalPages={selfListing.pagination.total_pages} 
                                                    currentPage={selfListing.pagination.page} 
                                                    onPageChange={handlePageChange} 
                                                />
                                            : ''
                                        }
                                    </div> 
                               </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    return {
        selfListing: state.property.selfListing
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getSelfProperties: (post) => dispatch(actions.getSelfProperties(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(Properties);